<template>
  <div class="call-center" v-if="showCallCenter">
    <v-btn
      class="lead-bottom-control-panel__btn ml-2"
      v-if="!onPhone"
      color="green darken-1"
      dark
      @click="toggleCall"
    >
      <v-icon color="white">mdi-phone</v-icon>
      <span class="lead-bottom-control-panel__item-text">Call</span>
    </v-btn>
    <div v-else>
      <v-btn
        :color="muted ? 'red darken-1' : 'blue-grey darken-1'"
        class="lead-bottom-control-panel__btn white--text ml-2 mt-1 mb-1"
        @click="toggleMute"
      >
        <v-icon v-if="muted" color="white">mdi-microphone</v-icon>
        <v-icon v-else color="white">mdi-microphone-off</v-icon>
        <span class="lead-bottom-control-panel__item-text">{{
          muted ? "Muted" : "Mute"
        }}</span>
      </v-btn>
      <HoldHandler v-if="callType == 'conf'" />
      <CallSecondParticipiant :lead_id="lead_id" v-if="callType == 'conf'" />
      <Dialpad :connection="connection" />
      <v-btn
        color="red darken-1"
        class="lead-bottom-control-panel__btn ml-2 mt-1 mb-1"
        dark
        @click="toggleCall"
      >
        <v-icon color="white">mdi-phone-hangup</v-icon>
        <span class="lead-bottom-control-panel__item-text">Hang up</span>
      </v-btn>
    </div>
    <v-radio-group class="ml-4" v-model="callType">
      <v-radio label="Conference" value="conf"></v-radio>
      <v-radio label="Single" value="single"></v-radio>
    </v-radio-group>
    <template v-if="second_number">
      <v-radio-group class="ml-4" v-model="callNumber">
        <v-radio :label="number" :value="number"></v-radio>
        <v-radio :label="second_number" :value="second_number"></v-radio>
      </v-radio-group>
    </template>
    <div class="status-block">
      <h4>Status: {{ status }}</h4>
      <p class="notification my-0">
        Be sure that you have connected microphone or headset!
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import { Device } from "twilio-client";

import CallSecondParticipiant from "@/components/twillio/CallSecondParticipiant";
import Dialpad from "@/components/twillio/Dialpad";
import HoldHandler from "@/components/twillio/HoldHandler";

export default {
  name: "CallCenter",
  props: {
    lead_id: Number,
    number: String,
    second_number: {
      type: String,
      required: false,
    },
    status_lead: String,
  },
  components: {
    CallSecondParticipiant,
    HoldHandler,
    Dialpad,
  },
  data() {
    return {
      formatedPhone: null,
      status: "Connecting...",
      connection: null,
      record_id: null,
      callType: "conf",
      callNumber: this.number,
      muted: false,
      outbound: false
    };
  },
  mounted() {
    this.sockets.subscribe("SET_CONF_PARAMS", () => {});
    this.sockets.subscribe("SET_SECOND_PARTICIPIANT_PARAMS", () => {});
  },
  created() {
    if (!this.online) {
      this.$axios
        .post("/call/token/" + this.user.id)
        .then((res) => {
          Device.setup(res.data.token, {
            debug: process.env.NODE_ENV === "development" ? true : false,
          });
        })
        .catch((err) => {
          console.log(err);
          this.status = "Connection lost...";
        });
    }

    // Configure event handlers for Twilio Device
    Device.disconnect(() => {
      // this.onPhone = false;
      this.SET_ON_PHONE(false);
      this.SET_SECOND_PARTICIPIANT(false);
      
      if(this.wasOnline){
        this.$socket.emit("set_online_status", {
          id: this.user.id,
          status: true,
        });

        this.setOnlineStatus(true);    
      }


      this.connection = null;
      this.status = "Call ended.";
    });

    Device.ready(() => {
      this.status = "Connected to Twilio";
    });
  },

  methods: {
    ...mapActions({
      showHandlerSnackbar: "snackbar/showHandlerSnackbar",
      twilioTokenHandler: "auth/twilioTokenHandler",
    }),
    ...mapMutations({
      SET_UNCOMPLETED_LEAD: "auth/SET_UNCOMPLETED_LEAD",
      SET_ON_PHONE: "coldCall/SET_ON_PHONE",
      SET_LEAD_ID: "coldCall/SET_LEAD_ID",
      SET_HOLD: "conference/SET_HOLD",
      SET_SECOND_PARTICIPIANT: "conference/SET_SECOND_PARTICIPIANT",
      setOnlineStatus: "auth/SET_ONLINE_STATUS",
    }),


    toggleMute() {
      this.muted = !this.muted;
      Device.activeConnection().mute(this.muted);
    },

    setOnHold() {
      this.SET_HOLD(!this.hold);
      this.$axios.post("/call/conference/handle-hold", {
        callSid: this.confParams.callSid,
        conferenceSid: this.confParams.conferenceSid,
        hold: this.hold,
      });
    },
    toggleCall() {
      if (!this.onPhone) {

        if(this.online){
          this.wasOnline = true;
          
          this.$socket.emit("set_online_status", {
            id: this.user.id,
            status: false,
          });
          this.setOnlineStatus(false);
        } else {
          this.wasOnline = false;
        }
        
        this.SET_HOLD(false);
        this.muted = false;
        // this.onPhone = true;
        this.SET_ON_PHONE(true);
        let formatedNumber = this.callNumber.replace(/[^\d]/g, "");
        const number = "+1" + formatedNumber;

        this.formatedPhone = number;

        this.connection = Device.connect({
          number,
          lead_id: this.lead_id,
          user_id: this.user.id,
          callType: this.callType,
        });

        this.status = "Calling " + number;

        this.SET_LEAD_ID(this.lead_id);

        this.$axios
          .patch(`/agents/${this.user.id}/start-work/${this.lead_id}`)
          .then((res) => {
            // this.SET_UNCOMPLETED_LEAD(+this.lead_id);
            this.showHandlerSnackbar({
              color: res.data.status,
              text: res.data.message,
              show: true,
            });
          })
          .catch((err) => {
            this.showHandlerSnackbar({
              color: err.response.data.status,
              text: err.response.data.message,
              show: true,
            });
          });
      } else {
        Device.disconnectAll();
      }
    },
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
      onPhone: "coldCall/onPhone",
      hold: "conference/hold",
      confParams: "twilio/confParams",
      online: "auth/online",
    }),
    showCallCenter: {
      get: function () {
        if (this.status_lead == "notInterested") return false;
        return true;
      },
    },
  },
};
</script>

<style lang="scss">
.status-block {
  margin-left: 20px;
  font-size: 18px;
}
.notification {
  color: #757575;
  font-size: 14px;
}
.call-center {
  display: flex;
  align-items: center;
}
</style>